;<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3.6V4.4C13 4.73137 12.7314 5 12.4 5H3.6C3.26863 5 3 4.73137 3 4.4V3.6C3 3.26863 3.26863 3 3.6 3H12.4C12.7314 3 13 3.26863 13 3.6Z"
      stroke="#21242C"
    />
    <path
      d="M13 7.6V8.4C13 8.73137 12.7314 9 12.4 9H3.6C3.26863 9 3 8.73137 3 8.4V7.6C3 7.26863 3.26863 7 3.6 7H12.4C12.7314 7 13 7.26863 13 7.6Z"
      stroke="#21242C"
    />
    <path
      d="M13 11.6V12.4C13 12.7314 12.7314 13 12.4 13H3.6C3.26863 13 3 12.7314 3 12.4V11.6C3 11.2686 3.26863 11 3.6 11H12.4C12.7314 11 13 11.2686 13 11.6Z"
      stroke="#21242C"
    />
  </svg>
</template>
